// material-ui
import { useTheme } from '@mui/material/styles';

// assets
import logoDark from 'assets/logo-dark.png';
import logoLight from 'assets/logo-light.png';

// ==============================|| LOGO ICON SVG ||============================== //

export default function LogoIcon() {
  const theme = useTheme();

  return (
    <img src={theme.palette.mode === 'dark' ? logoDark : logoLight} alt="Bizora" width="35" />
  );
}
